// extracted by mini-css-extract-plugin
export var selectRoot = "styles-module__selectRoot___nz_mI";
export var selectFocused = "styles-module__selectFocused___KJw8D";
export var menuItemRoot = "styles-module__menuItemRoot___bo0Po";
export var icon = "styles-module__icon___NcM60";
export var activeIcon = "styles-module__activeIcon___ypbKP";
export var menuRoot = "styles-module__menuRoot___EPSoP";
export var slim = "styles-module__slim___X1Y1f";